export interface OptionsType {
  label: string;
  value: number | string;
}
export const getConvertedMetaData = (
  data: any,
  language?: string | null | undefined,
) => {
  const LANGUAGE = {
    BANGLA: "bn",
    ENGLISH: "en",
  };

  let convertedData = [] as OptionsType[];
  data &&
    data.forEach((item: any) => {
      let selectOptions = {} as OptionsType;
      selectOptions.label =
        language === LANGUAGE.BANGLA
          ? item?.nameBn ||
            item?.name_bn ||
            item?.bn_name ||
            item?.buildingName ||
            item?.type ||
            item?.roomNo ||
            item?.name ||
            item?.vendorName
          : item?.nameEn ||
            item?.name_en ||
            item?.en_name ||
            item?.buildingName ||
            item?.type ||
            item?.roomNo ||
            item?.name ||
            item?.vendorName;
      selectOptions.value = item.id;

      convertedData.push(selectOptions);
    });

  return convertedData?.sort((a, b) => String(a.label).localeCompare(b.label));
};

export const getConvertedMetaDataForEmployee = (
  data: any,
  language?: string | null | undefined,
  valueAsNumber?: boolean,
) => {
  const LANGUAGE = {
    BANGLA: "bn",
    ENGLISH: "en",
  };

  let convertedData = [] as OptionsType[];
  data &&
    data.forEach((item: any) => {
      let selectOptions = {} as OptionsType;
      selectOptions.label =
        language === LANGUAGE.BANGLA
          ? item.nameBn ||
            item.name_bn ||
            item.bn_name ||
            `${item.roomNo || ""}` ||
            `${item.deskNumber || ""}` ||
            item.name ||
            item.type ||
            item.buildingName
          : item.nameEn ||
            item.name_en ||
            item.en_name ||
            item.buildingName ||
            `${item.roomNo || ""}` ||
            `${item.deskNumber || ""}` ||
            item.name ||
            item.type;
      selectOptions.value = valueAsNumber ? item.id : `${item.id}`;

      convertedData.push(selectOptions);
    });

  return convertedData?.sort((a, b) => String(a.label).localeCompare(b.label));
};

export const getConvertedMetaDataForEmployeeAsset = (
  data: any,
  language?: string | null | undefined,
) => {
  const LANGUAGE = {
    BANGLA: "bn",
    ENGLISH: "en",
  };

  let convertedData = [] as OptionsType[];
  data &&
    data.forEach((item: any) => {
      let selectOptions = {} as OptionsType;
      selectOptions.label =
        language === LANGUAGE.BANGLA
          ? `${item.nameBn || item.name_bn || item.bn_name || item.name} ~ ${
              item.barCode
            }`
          : `${item.nameEn || item.name_en || item.en_name || item.name} ~ ${
              item.barCode
            }`;

      selectOptions.value = item.id;

      convertedData.push(selectOptions);
    });

  return convertedData?.sort((a, b) => String(a.label).localeCompare(b.label));
};

export const getConvertedUnitMetaData = (
  data: any,
  language?: string | null | undefined,
) => {
  const LANGUAGE = {
    BANGLA: "bn",
    ENGLISH: "en",
  };

  let convertedData = [] as OptionsType[];
  data &&
    data.forEach((item: any) => {
      let selectOptions = {} as OptionsType;
      selectOptions.label =
        language === LANGUAGE.BANGLA
          ? item.nameBn ||
            item.name_bn ||
            item.bn_name ||
            item.buildingName ||
            item.type ||
            item.name
          : item.nameEn ||
            item.name_en ||
            item.en_name ||
            item.buildingName ||
            item.type ||
            item.name;
      selectOptions.value = item.name;

      convertedData.push(selectOptions);
    });

  return convertedData?.sort((a, b) => a.label.localeCompare(b.label));
};

export const getConvertedMetaDataForInventoryRoom = (
  data: any,
  language?: string | null | undefined,
) => {
  const dataWithoutConf = data.filter((item: any) => item.id !== 1);

  const LANGUAGE = {
    BANGLA: "bn",
    ENGLISH: "en",
  };

  let convertedData = [] as OptionsType[];
  dataWithoutConf &&
    dataWithoutConf.forEach((item: any) => {
      let selectOptions = {} as OptionsType;
      selectOptions.label =
        language === LANGUAGE.BANGLA
          ? item.nameBn ||
            item.name_bn ||
            item.bn_name ||
            item.buildingName ||
            item.type ||
            item.roomNo ||
            item.name ||
            item.vendorName
          : item.nameEn ||
            item.name_en ||
            item.en_name ||
            item.buildingName ||
            item.type ||
            item.roomNo ||
            item.name ||
            item.vendorName;
      selectOptions.value = item.id;

      convertedData.push(selectOptions);
    });

  return convertedData?.sort((a, b) => String(a.label).localeCompare(b.label));
};

export const getConvertedOfficeData = (
  data: any,
  language?: string | null | undefined,
) => {
  const LANGUAGE = {
    BANGLA: "bn",
    ENGLISH: "en",
  };

  let convertedData = [] as OptionsType[];
  data &&
    data.forEach((item: any) => {
      let selectOptions = {} as OptionsType;
      selectOptions.label =
        language === LANGUAGE.BANGLA ? item.nameBn : item.name;
      selectOptions.value = item.id;

      convertedData.push(selectOptions);
    });

  return convertedData?.sort((a, b) => String(a.label).localeCompare(b.label));
};
